<template>
  <!-- -->
  <div class="home-page">
    <div class="layout-top">
      <component :is="homeTopName"/>
    </div>
    <div class="layout-main">
      <div
        class="layout-left"
        :class="isCollapse ? 'layout-left-collapse' : ''"
      >
        <home-menu
          ref="homeMenu"
          @addTab="addTab"
          :is-collapse="isCollapse"
          :menu-list="menuList"
          :selected-menu="selectedMenu"
        />
      </div>
      <div class="layout-center">
        <div class="layout-tabs">
          <div class="tabs" @click="isCollapse = !isCollapse">
            <yq-icon v-if="isCollapse" name="element-ui_s-unfold" />
            <yq-icon v-else name="element-ui_s-fold" />
          </div>
          <div
            class="tabs"
            :class="
              selectedTab === '/' || selectedTab === '/welcome' ? 'on' : ''
            "
            @click="tabClick('/', '/')"
          >
            <yq-icon class="home-icon" name="element-ui_s-home" />
          </div>
          <!-- 业务页签滚动区：超宽时可横向滚动，滚动条隐藏 -->
          <div
            class="tabs-scroll"
            :class="{
              'can-scroll-left': showTabsScrollLeft,
              'can-scroll-right': showTabsScrollRight,
            }"
          >
            <div
              v-if="showTabsScrollLeft"
              class="tabs-scroll-btn left"
              @click.stop="scrollTabs(-1)"
            >
              <yq-icon name="element-ui_arrow-left" />
            </div>
            <div
              ref="tabsTrack"
              class="tabs-track"
              @scroll="updateTabsScroll"
              @wheel="onTabsWheel"
            >
              <div
                v-for="(item, idx) in tabs"
                :key="idx"
                class="tabs"
                :class="selectedTab === item.path ? 'on' : ''"
                @click="tabClick(item.path, item.fullPath)"
                @contextmenu="rightClick($event, 2)"
              >
                <span class="tabs-text">{{ item.moduleName }}</span>
                <yq-icon
                  name="element-ui_close"
                  @click.stop="tabClose(item, idx)"
                />
              </div>
            </div>
            <div
              v-if="showTabsScrollRight"
              class="tabs-scroll-btn right"
              @click.stop="scrollTabs(1)"
            >
              <yq-icon name="element-ui_arrow-right" />
            </div>
          </div>
        </div>
        <div class="layout-container">
          <div class="layout-view">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="menuVisible"
      class="custom-menu"
      :style="{ top: menuPosition.y + 'px', left: menuPosition.x + 'px' }"
    >
      <div
        class="li"
        v-if="!menuPosition.isHome"
        @click="closeTabs('closeOthers')"
      >
        <yq-icon name="element-ui_d-caret" rotate-z="90deg" />{{
          $t("message.closeOtherTabs")
        }}
      </div>
      <div
        class="li"
        v-if="!menuPosition.isHome"
        @click="closeTabs('closeLeft')"
      >
        <yq-icon name="element-ui_caret-left" />{{
          $t("message.closeLeftTabs")
        }}
      </div>
      <div
        class="li"
        v-if="!menuPosition.isHome"
        @click="closeTabs('closeRight')"
      >
        <yq-icon name="element-ui_caret-right" />{{
          $t("message.closeRightTabs")
        }}
      </div>
      <div class="li" @click="closeTabs('closeAll')">
        <yq-icon name="element-ui_d-caret" rotate-z="90deg" />{{
          $t("message.closeAllTabs")
        }}
      </div>
    </div>
    <!-- AI 智能助手悬浮对话（全系统任意页面可见）；AI 打开菜单时复用 addTab 跳转 -->
    <ai-chat-dialog @ai-open-menu="addTab"/>
  </div>
</template>

<script>
import CommonHomeTop from "@/views/h5/common/home/components/top/CommonHomeTop.vue"; // 通用顶部功能
import CommonMessageRestHomeTop from "@/views/h5/common/home/components/top/CommonMessageRestHomeTop.vue";
import RoadHomeTop from "@/views/h5/luqiao/home/RoadHomeTop.vue"; // 路桥顶部功能
import CommonMessageWsHomeTop from "@/views/h5/common/home/components/top/CommonMessageWsHomeTop.vue";
import RoadMessageWsHomeTop from "@/views/h5/luqiao/home/RoadMessageWsHomeTop.vue";

import HomeMenu from "@/views/h5/common/home/HomeMenu.vue";
import AiChatDialog from "@/views/h5/common/home/components/AiChatDialog.vue"; // AI 智能助手悬浮对话
import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
import commonApi from "@/api/commonApi";
import { useRoute, useRouter } from "vue-router";

// 页签滚动区悬浮按钮占位宽度：right 4px + 宽 26px = 30px。
// 额外留 2px 是因为页签宽度和滚动位置都可能是小数，getBoundingClientRect 累加加上
// scrollLeft 取整会产生亚像素误差，按 30 计算实测只能到 29px，页签会被按钮压住 1px。
const TAB_SCROLL_BTN_PADDING = 32;
// scrollWidth/clientWidth 取整会让可滚上限虚高 1~2px，判定临界点时的容差
const SCROLL_EPSILON = 2;

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    };
  },
  name: "HomeMain",
  components: {
    YqIcon, CommonHomeTop, RoadHomeTop, HomeMenu, CommonMessageRestHomeTop, CommonMessageWsHomeTop, RoadMessageWsHomeTop, AiChatDialog
  },
  data() {
    return {
      homeTopName: process.env.VUE_APP_HOME_TOP, // 使用哪个顶部组件
      tabs: [],
      selectedTab: "/", // 首页被选中的页签
      selectedMenu: [], // 被选中的菜单
      isCollapse: false, // 是否收起
      maxTabsLength: 20,
      menuList: [
      ], // 系统菜单
      menuVisible: false,
      menuPosition: {
        isHome: false,
        x: 0,
        y: 0,
      },
      showTabsScrollLeft: false, // 页签区是否可以向左滚动
      showTabsScrollRight: false, // 页签区是否可以向右滚动
    };
  },
  created() {
    // 向util中注册一个页签函数，用于检查页签数量
    util.setTabsCheck(this.checkTabsNumber);
    // 查询菜单
    this.loadMenu();
    // H5页面不能在手机端打开
    let context = util.getContextPath();
    if (context !== 1 && context !== 2) {
      this.$message.error("请在电脑端打开页面");
      this.router.push(`/qywx/home`);
    }
    // 系统页面初始化的时候，清理掉缓存的页面
    for (let k in sessionStorage) {
      if (k.startsWith("/")) {
        sessionStorage.removeItem(k);
      }
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      // 窗口缩放、左侧菜单收缩都会改变页签区宽度，监听尺寸变化重新计算滚动状态
      if (window.ResizeObserver) {
        this.tabsResizeObserver = new ResizeObserver(() => {
          this.updateTabsScroll();
        });
        if (this.$refs.tabsTrack) {
          this.tabsResizeObserver.observe(this.$refs.tabsTrack);
        }
      }
      this.updateTabsScroll();
    });
  },
  unmounted() {
    if (this.tabsResizeObserver) {
      this.tabsResizeObserver.disconnect();
      this.tabsResizeObserver = null;
    }
  },
  watch: {
    // 增删页签只改变滚动内容宽度，不改变容器尺寸，ResizeObserver 不会触发，需要单独监听
    tabs() {
      this.$nextTick().then(() => {
        this.updateTabsScroll();
      });
    },
  },
  methods: {
    closeTabs(command) {
      switch (command) {
        case "closeOthers":
          for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].path === this.selectedTab) {
              this.tabs = [this.tabs[i]];
              break;
            }
          }
          break;
        case "closeLeft":
          for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].path === this.selectedTab) {
              this.tabs = this.tabs.slice(i, this.tabs.length);
              break;
            }
          }
          break;
        case "closeRight":
          for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].path === this.selectedTab) {
              this.tabs = this.tabs.slice(0, i + 1);
              break;
            }
          }
          break;
        case "closeAll":
          this.tabs = [];
          this.router.push("/");
          break;
      }
    },
    rightClick(event, type) {
      event.preventDefault();
      // 设置自定义菜单的位置
      this.menuPosition.x = event.clientX;
      this.menuPosition.y = event.clientY;
      this.menuPosition.isHome = type === 1;
      // 显示自定义菜单
      this.menuVisible = true;
      // 添加document的点击事件，用于关闭自定义菜单
      document.addEventListener("click", this.closeCustomMenu);
    },
    closeCustomMenu() {
      // 隐藏自定义菜单
      this.menuVisible = false;
      // 移除document的点击事件
      document.removeEventListener("click", this.closeCustomMenu);
    },
    // 计算页签滚动区两端是否还有可滚动的内容，决定左右按钮的显隐
    updateTabsScroll() {
      const track = this.$refs.tabsTrack;
      if (!track) {
        return;
      }
      // scrollWidth/clientWidth 是取整后的整数，浏览器实际可滚上限是小数，
      // 用它相减得到的 max 会比真实上限大 1~2px，导致滚到底时仍判定"还能滚"、
      // 按钮不消失并压住最后一个页签。故留 2px 容差。
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      this.showTabsScrollLeft = track.scrollLeft > SCROLL_EPSILON;
      this.showTabsScrollRight = track.scrollLeft < maxScrollLeft - SCROLL_EPSILON;
    },
    // 点击左右按钮：按一屏的 80% 滚动，保留部分重叠便于识别当前位置
    scrollTabs(direction) {
      const track = this.$refs.tabsTrack;
      if (!track) {
        return;
      }
      track.scrollBy({
        left: direction * track.clientWidth * 0.8,
        behavior: "smooth",
      });
    },
    // 把指定页签滚动到可见位置。
    // 不直接用 scrollIntoView：它是滚到「贴边即算可见」，页签会被左右悬浮按钮遮住，
    // 所以这里按内边距做精确计算，保证完整露出。
    scrollTabIntoView(path) {
      this.$nextTick().then(() => {
        const track = this.$refs.tabsTrack;
        if (!track) {
          return;
        }
        // 按当前页签顺序找到目标元素，避免给 tab 加 ref 带来的维护成本
        const idx = this.tabs.findIndex(tab => tab.path === path);
        if (idx === -1) {
          return;
        }
        const tabEl = track.children[idx];
        if (!tabEl) {
          return;
        }
        // 给左右悬浮按钮留出空间，避免滚到了但被按钮盖住
        const btnPadding = TAB_SCROLL_BTN_PADDING;
        const trackRect = track.getBoundingClientRect();
        const tabRect = tabEl.getBoundingClientRect();
        // 页签相对滚动区内容左侧的位置（trackRect 会随滚动变化，需加上 scrollLeft）
        const tabLeft = tabRect.left - trackRect.left + track.scrollLeft;
        const tabRight = tabLeft + tabRect.width;
        const viewLeft = track.scrollLeft + btnPadding;
        const viewRight = track.scrollLeft + track.clientWidth - btnPadding;
        let targetScrollLeft = null;
        if (tabLeft < viewLeft) {
          // 页签在左侧不可见（或部分被按钮遮挡），滚到左内边距处
          targetScrollLeft = tabLeft - btnPadding;
        } else if (tabRight > viewRight) {
          // 页签在右侧不可见（或部分被按钮遮挡），滚到右内边距处
          targetScrollLeft = tabRight - track.clientWidth + btnPadding;
        }
        // 已经完全可见，不做无谓滚动
        if (targetScrollLeft === null) {
          return;
        }
        // 同样用容差钳制上限，保证与 updateTabsScroll 的"到底"判定一致，
        // 否则会停在差 1px 的位置、按钮不消失
        targetScrollLeft = Math.max(
          0,
          Math.min(
            targetScrollLeft,
            track.scrollWidth - track.clientWidth - SCROLL_EPSILON
          )
        );
        track.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
      });
    },
    // 页签区只支持横向滚动，把竖向滚轮转换成横向滚动
    onTabsWheel(event) {
      const track = this.$refs.tabsTrack;
      if (!track || event.deltaY === 0) {
        return;
      }
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      if (maxScrollLeft <= 0) {
        return;
      }
      const nextScrollLeft = track.scrollLeft + event.deltaY;
      // 滚到两端时不再拦截，避免影响页面本身的滚动
      if (nextScrollLeft < 0 || nextScrollLeft > maxScrollLeft) {
        return;
      }
      event.preventDefault();
      track.scrollLeft = nextScrollLeft;
    },
    // 选中某一个菜单，由menu触发
    addTab(url) {
      const resolved = this.router.resolve(url);
      const path = resolved.path;
      const fullPath = resolved.fullPath;
      // 页签已满且目标页签不在列表中：不添加页签、不跳转、阻止菜单选中
      if (!this.isTabExists(path) && this.tabs.length >= this.maxTabsLength) {
        this.$message.error(this.$t("message.muchMoreTabs"));
        // 阻止左侧菜单的选中
        if (this.$refs.homeMenu && this.$refs.homeMenu.resetSelect) {
          this.$refs.homeMenu.resetSelect();
        }
        return;
      }
      this.addTabs2Home(path, fullPath);
      this.$refs.homeMenu.routerPush(url);
    },
    // 在首页页签上点击，切换到这个页面
    tabClick(path, fullPath) {
      this.$refs.homeMenu.routerPush(fullPath);
      this.selectedTab = path;
      // 选中菜单
      this.addTabs2Home(path, fullPath);
    },
    // 判断目标页签是否已经存在于页签列表中
    isTabExists(path) {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].path === path) {
          return true;
        }
      }
      return false;
    },
    // 检测菜单数量,如果这个菜单不在menu中，需要从route中获取菜单添加到列表上,checkTabsNumber是通过js触发进来的，不是通过点击进来，不需要router.push操作
    checkTabsNumber(to) {
      // 首页/欢迎页不占页签，始终放行
      if (to.path === "/" || to.path === "/welcome") {
        return;
      }
      // 目标页签已存在（切换已打开的页面），不新增，直接放行
      if (this.isTabExists(to.path)) {
        this.addTabs2Home(to.path, to.fullPath);
        return;
      }
      // 目标是新页签且页签已满，阻止跳转，不再添加页签
      if (this.tabs.length >= this.maxTabsLength) {
        this.$message.error(this.$t("message.muchMoreTabs"));
        // 阻止左侧菜单的选中
        if (this.$refs.homeMenu && this.$refs.homeMenu.resetSelect) {
          this.$refs.homeMenu.resetSelect();
        }
        throw new Error("菜单数量超出限制");
      } else {
        // 将页签添加到首页中
        this.addTabs2Home(to.path, to.fullPath);
      }
    },
    // 关闭菜单
    tabClose(item, idx) {
      // 删除这个菜单
      this.tabs.splice(idx, 1);
      // 如果是关闭当前页面，跳转到下一个页面/上一个页面/首页
      if (item.path === this.route.path) {
        // 跳转到下一个页面
        if (idx === 0) {
          if (this.tabs.length > 0) {
            this.$refs.homeMenu.routerPush(this.tabs[0].fullPath);
            this.selectedTab = this.tabs[0].path;
          } else {
            this.$refs.homeMenu.routerPush("/");
            this.selectedTab = "/";
          }
        } else {
          // 跳转到上一个页面
          this.$refs.homeMenu.routerPush(this.tabs[idx - 1].fullPath);
          this.selectedTab = this.tabs[idx - 1].path;
        }
      }
      this.$nextTick().then(() => {
        util.removeTab(item.path);
      });
    },
    // 加载系统菜单
    loadMenu() {
       // = await systemModuleApi.queryModuleTree()
      commonApi.getMenu(1).then(list => {
        this.menuList = list;
        // 缓存菜单
        util.setSession("menuList", JSON.stringify(this.menuList));
        // 显示当前页面的页签
        this.addTabs2Home(this.route.path, this.route.fullPath);
      })
    },
    // 从菜单中，按url找到对应的数据,返回父子菜单
    findModule(list, url) {
      for (let i = 0; i < list.length; i++) {
        if (url === list[i].moduleComponentUri) {
          return [list[i]];
        }
        if (list[i].children && list[i].children.length > 0) {
          let res = this.findModule(list[i].children, url);
          if (res && res.length > 0) {
            let result = [list[i]];
            return result.concat(res);
          }
        }
      }
      return [];
    },
    // 递归查找，匹配路径的菜单
    findModuleAsLike(list, url) {
      for (let i = 0; i < list.length; i++) {
        if (url.startsWith(list[i].moduleComponentUri)) {
          return [list[i]];
        }
        if (list[i].children && list[i].children.length > 0) {
          let res = this.findModuleAsLike(list[i].children, url);
          if (res && res.length > 0) {
            let result = [list[i]];
            return result.concat(res);
          }
        }
      }
      return [];
    },
    // 驼峰转连接线
    camel2line(camelCaseString) {
      return camelCaseString.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    },
    // 将页签添加到首页
    addTabs2Home(path, fullPath) {
      // 首页，不需要添加页签
      if (path === "/" || path === "/welcome") {
        return;
      }
      // 不是主页，要向tab添加菜单
      let modules = this.findModule(this.menuList, path);
      if (modules && modules.length) {
        let module = modules[modules.length - 1];
        // 这是一个系统菜单
        this.addTabs2Home2({
          moduleName: module.moduleName,
          path: module.moduleComponentUri,
          fullPath: fullPath
        });
        this.showMenuSelected(modules);
      } else {
        // 这个菜单不存在，说明是详情页面,从route中获取
        let list = this.router.getRoutes();
        for (let i = 0; i < list.length; i++) {
          if (path === list[i].path) {
            this.addTabs2Home2({
              moduleName: list[i].meta.title || list[i].name,
              path: path,
              fullPath: fullPath
            });
            // 通过path,找到对应的上级菜单
            this.showMenuSelected(this.findModuleAsLike(this.menuList, path));
            break;
          }
        }
      }
    },
    // 显示菜单的选中状态
    showMenuSelected(modules) {
      let arr = [];
      for (let i = 0; i < modules.length; i++) {
        arr.push(modules[i].moduleComponentUri);
      }
      // 被选中的菜单
      this.selectedMenu = arr;
    },
    // 将页签添加到首页
    addTabs2Home2(tabData) {
      // 根据path，看这个页签是否已经存在
      for (let i = 0; i < this.tabs.length; i++) {
        if (tabData.path === this.tabs[i].path) {
          this.selectedTab = tabData.path;
          // 选中的页签可能在滚动区外，滚动到可见位置
          this.scrollTabIntoView(tabData.path);
          return;
        }
      }
      // 这个页签不存在，添加一个页签
      if (this.tabs.length < this.maxTabsLength) {
        // tabs中只有name和url两个属性
        this.tabs.push(tabData);
        this.selectedTab = tabData.path;
        // 新增的页签在末尾，可能在滚动区外，滚动到可见位置
        this.scrollTabIntoView(tabData.path);
      } else {
        this.$message.error(this.$t("message.muchMoreTabs"));
        throw new Error("tabs超出最大限制");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);

  .layout-top {
    flex-shrink: 0;
  }

  .layout-main {
    flex: 1;
    display: flex;
    height: 0;
    min-height: 0;

    .layout-left {
      width: 180px;
      min-width: 180px;
      max-width: 180px;
      background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
      color: #334155;
      overflow: hidden;
      border-right: 1px solid #e2e8f0;
      z-index: 10;
      box-shadow: 2px 0 12px rgba(0, 0, 0, 0.04);
      position: relative;
      flex-shrink: 0;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 3px;
        height: 100%;
        background: linear-gradient(180deg, transparent 0%, var(--el-color-primary) 50%, transparent 100%);
        z-index: 1;
      }

      &.layout-left-collapse {
        width: 65px;
        min-width: 65px;
        max-width: 65px;
        &::before {
          width: 2px;
        }
      }
    }

    .layout-center {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      // 关键：flex 子项默认 min-width:auto，会被内容撑到最小内容宽，
      // 不加这行页签变多时会把整个布局撑宽（页签滚动而非撑开页面）
      min-width: 0;
      background: #f8fafc;

      .layout-tabs {
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #e2e8f0;
        display: inline-flex;
        box-sizing: border-box;
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        z-index: 10;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
        flex-shrink: 0;
        overflow: hidden;

        .tabs {
          padding: 0 18px;
          cursor: pointer;
          user-select: none;
          position: relative;
          color: #64748b;
          transition: all 0.3s ease;
          border-radius: 8px 8px 0 0;
          margin-right: 2px;
          flex-shrink: 0;
          white-space: nowrap;

          &:hover {
            color: #1e293b;
            background: #f1f5f9;
          }

          .home-icon {
            font-size: 18px;
            vertical-align: middle;
          }

          &.on {
            background: #ffffff;
            color: #409eff;
            border-bottom: 2px solid #409eff;
          }

          .el-icon {
            margin-left: 8px;
            font-size: 12px;
            opacity: 0.7;
            transition: all 0.2s ease;
          }

          &:hover .el-icon {
            opacity: 1;
            transform: scale(1.1);
          }
        }

        .tabs-text {
          display: inline-block;
          white-space: nowrap;
          vertical-align: middle;
        }

        // 业务页签滚动区，占据折叠按钮和首页图标之外的剩余宽度
        .tabs-scroll {
          flex: 1;
          display: flex;
          min-width: 0;
          position: relative;
          overflow: hidden;

          // 还有内容时，在对应一侧做白色渐隐遮罩，让"被截断"的状态更明显
          &.can-scroll-left::before,
          &.can-scroll-right::after {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            width: 24px;
            z-index: 2;
            pointer-events: none;
          }

          &.can-scroll-left::before {
            left: 0;
            background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0));
          }

          &.can-scroll-right::after {
            right: 0;
            background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0));
          }
        }

        .tabs-track {
          flex: 1;
          min-width: 0;
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;
          // 尾部留出右侧悬浮按钮的宽度：滚到底时最后一个页签才不会停在按钮下面。
          // 该内边距同时计入 clientWidth 和 scrollWidth，不影响可滚动距离。
          padding-right: 30px;
          scrollbar-width: none; // Firefox
          -ms-overflow-style: none; // 旧版 Edge / IE

          &::-webkit-scrollbar {
            display: none; // Chrome / Safari，滚动过程中不显示滚动条
          }
        }

        // 左右滚动按钮：悬浮在滚动区两端，仅在对应方向仍有内容时出现。
        // 用实心圆 + 阴影，避免细线图标在白底上过于轻淡
        .tabs-scroll-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 26px;
          height: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #ffffff;
          border: 1px solid var(--yq-border-color);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
          color: #475569;
          cursor: pointer;
          z-index: 3;
          transition: all 0.2s ease;

          .yq-icon {
            font-size: 14px;
            font-weight: 700;
          }

          &.left {
            left: 4px;
          }

          &.right {
            right: 4px;
          }

          &:hover {
            color: #ffffff;
            background: var(--el-color-primary);
            border-color: var(--el-color-primary);
            box-shadow: 0 3px 10px rgba(64, 158, 255, 0.45);
          }

          &:active {
            transform: translateY(-50%) scale(0.92);
          }
        }
      }

      .layout-container {
        flex: 1;
        box-sizing: border-box;
        padding: 12px;
        min-height: 0;

        .layout-view {
          height: 100%;
          max-height: 100%;
          //background: #ffffff;
          //border-radius: 12px;
          //border: 1px solid #e2e8f0;
          //box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04),
          //            inset 0 1px 0 rgba(255, 255, 255, 0.8);
          overflow: hidden;
          box-sizing: border-box;
          position: relative;

          > * {
            height: 100%;
            width: 100%;
            overflow: auto;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}

.custom-menu {
  position: absolute;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  z-index: 9999;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08),
  0 0 0 1px #e2e8f0;
  border-radius: 10px;
  padding: 6px 0;
  min-width: 140px;

  .li {
    color: #64748b;
    padding: 8px 20px;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;

    .el-icon {
      margin-right: 10px;
      font-size: 14px;
    }
  }

  .li:hover {
    color: var(--el-color-primary);
    background: #eff6ff;
    cursor: pointer;
  }
}
</style>